var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',_vm._b({class:_vm.className,style:({ 'background-color': _vm.color, 'color': _vm.fontColor })},'td',{'scoped': _vm.scopedRow},false),[_c('span',{style:({ 'background-color': _vm.color })}),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef538694","hasScoped":true,"transformToRequire":{"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableDataCell.vue
// module id = uNoO
// module chunks = 1